module.exports = __webpack_public_path__ + "img/achievement-show.0c68607e.png";